import * as React from 'react'
import { Auth0Provider as AuthProvider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'

type AppState = {
  returnTo?: string
}

const Auth0Provider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()

  const onRedirectCallback = (appState: AppState | undefined) => {
    navigate(appState?.returnTo || '/vendors')
  }

  return (
    <AuthProvider
      domain={import.meta.env.VITE_AUTH0_DOMAIN || ''}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID || ''}
      redirectUri={`${window.location.protocol}//${window.location.host}/vendors`}
      audience={import.meta.env.VITE_AUTH0_AUDIENCE}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </AuthProvider>
  )
}

export default Auth0Provider
